import { Component, inject } from '@angular/core';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { NotificationPreferencesService } from 'src/app/shared/services/notification-preferences.service';
import { TranslationService } from 'src/app/shared/translations/services/translation.service';
import { NOTIFICATION_RESOURCE_TYPES } from 'src/app/shared/models/notification-resource-type.model';

@Component({
  selector: 'app-notifications-management',
  standalone: false,
  templateUrl: './notifications-management.component.html',
  styleUrls: ['./notifications-management.component.scss']
})
export class NotificationsManagementComponent {
  private readonly notificationPreferencesService = inject(NotificationPreferencesService);
  private readonly alertService = inject(AlertService);
  public readonly translationService = inject(TranslationService);

  public saving = false;
  public readonly notificationTypes = NOTIFICATION_RESOURCE_TYPES;

  public isNotificationTypeEnabled(resourceType: string): boolean {
    return this.notificationPreferencesService.isResourceTypeEnabled(resourceType);
  }

  public async toggleNotificationType(resourceType: string): Promise<void> {
    const targetValue = !this.notificationPreferencesService.isResourceTypeEnabled(resourceType);
    this.saving = true;
    try {
      const success = await this.notificationPreferencesService.setResourceTypeEnabled(resourceType, targetValue);
      if (!success) {
        this.alertService.showAlert({
          type: AlertType.critical,
          content: this.translationService.translate('notificationPreferenceSaveErrorText') || 'Failed to save notification preference.'
        } as Alert);
      }
    } finally {
      this.saving = false;
    }
  }
}
